import ethBlocks from './eth-blocks/metainfo';
// import aave from './aave-dapp/metainfo';
import ens from './ens-manager-dapp/metainfo';
import staked from './staked-dapp/metainfo';
import stakewise from './stakewise/metainfo';
import unstoppable from './unstoppable-domains-dapp/metainfo';
import rns from './rns-manager-dapp/metainfo';
import coinbaseStaking from './coinbase-staking/metainfo';
import flyover from './flyover-dapp/metainfo';
import rootstockCollective from './rootstock-collective-dapp/metainfo';
export default {
  coinbaseStaking,
  staked,
  stakewise,
  ens,
  ethBlocks,
  // aave,
  unstoppable,
  rns,
  flyover,
  rootstockCollective
};
